import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { clone } from 'ramda';

// import logger from '../utils/logger';
import { constantsRegistry } from '../../constants/tableConstantsFactory';
import changeReducerFactory from './changeReducerFactory';
import detailReducerFactory from './detailReducerFactory';
import { reduceReducers } from '../applyReducer';
import { applyNullRemove } from '../../utils/contentTools';
import notificationConstants from '../../constants/notificationConstants';

// REDUCER METHODS

const changeContent = (state, action) => {
  const changeEvent = action.changeEvent;
  if (!changeEvent) {
    return state;
  }
  const active = _objectSpread(_objectSpread({}, state.active), {}, {
    content: changeEvent.content
  });
  if (active.content) {
    active.content = applyNullRemove(clone(active.content));
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    active,
    pendingChanges: true
  });
};
const clear = state => _objectSpread({}, state);
const createModal = state => _objectSpread(_objectSpread({}, state), {}, {
  activeAlert: true
});
const removeModal = state => _objectSpread(_objectSpread({}, state), {}, {
  activeAlert: false
});
const formatChange = (state, action) => {
  var _state$active;
  if (action.id && (_state$active = state.active) !== null && _state$active !== void 0 && _state$active.id && action.id !== state.active.id) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    // replace the format
    active: _objectSpread(_objectSpread({}, state.active), {}, {
      format: action.format
    })
  });
};
export default function contentChangeReducerFactory(entity) {
  const constants = constantsRegistry(entity);
  const changeReducer = changeReducerFactory(entity);
  const detailReducer = detailReducerFactory(entity);
  const computeCache = data => {
    if (entity === 'user') {
      return {};
    }
    let formatField = 'ReportType';
    if (entity === 'form') {
      formatField = 'formType';
    } else if (entity === 'issue') {
      formatField = 'issueType';
    }
    const staticContent = JSON.parse(data[formatField].staticContent || '{}');
    const formatInput = JSON.parse(data[formatField].formatInput || '{}');
    return {
      staticContent,
      formatInput
    };
  };
  const addCache = (state, action) => {
    const active = state.active;
    const data = Array.isArray(action.data) ? action.data[0] : action.data;
    // get what we need out of active and the most recent data.
    const composite = _objectSpread(_objectSpread({}, active), data);
    const result = _objectSpread(_objectSpread({}, state), {}, {
      activeCache: computeCache(composite)
    });
    return result;
  };
  const create = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    activeCache: {
      staticContent: action.defaultData.staticContent,
      formatInput: action.defaultData.format
    }
  });

  // note that the returned object is intended for composition and client code will need to call
  // `applyReducers(reducers, state)` to get an expected redux reducer
  return {
    reducers: {
      [constants.CREATE]: create,
      [constants.CHANGE_CONTENT]: changeContent,
      [constants.FORMAT_CHANGE]: formatChange,
      [constants.SHOW_CANCEL]: reduceReducers(detailReducer.reducers[constants.SHOW_CANCEL], clear),
      [constants.SHOW_SUCCESS]: reduceReducers(detailReducer.reducers[constants.SHOW_SUCCESS], addCache, clear),
      [constants.SAVE_SUCCESS]: reduceReducers(changeReducer.reducers[constants.SAVE_SUCCESS], clear),
      [constants.UNDO_CHANGES]: reduceReducers(changeReducer.reducers[constants.UNDO_CHANGES], clear),
      [notificationConstants.CREATE_MODAL]: createModal,
      [notificationConstants.DISMISS]: removeModal
    },
    initState: _objectSpread(_objectSpread({}, changeReducer.initState), {}, {
      activeAlert: false
    })
  };
}